module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0127.jpg?v=2a230cd8";